import { render } from "./Social.vue?vue&type=template&id=0eaa3486&scoped=true"
const script = {}

import "./Social.vue?vue&type=style&index=0&id=0eaa3486&scoped=true&lang=css"

import exportComponent from "D:\\rober\\RobertVS\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eaa3486"]])

export default __exports__